import { shape, number, string } from 'prop-types';

export const CandidateOpportunityShape = shape({
  displayBillingRate: string,
  hourlyRateBurdened: number,
  proposedHourlyCompensation: number,
  proposedHourlyRate: number,
  proposedMarginTarget: number,
});
